module.exports = __webpack_public_path__ + "static/media/SoManyPerks.6ba7ecda.png";